import { Callback } from 'src/app/auth/pages/callback'
import { Login } from 'src/app/auth/pages/login'
import { TermsOfServicePage } from 'src/app/auth/pages/terms'
import { RouteObject } from 'src/app/core/interface'
import { RedirectIfAuthenticated } from 'src/app/core/routes/components/redirect-if-authenticated'

export const authRoutes: RouteObject[] = [
  {
    children: [
      {
        path: '/login',
        element: (
          <RedirectIfAuthenticated>
            <Login />
          </RedirectIfAuthenticated>
        ),
      },
      {
        path: '/auth/callback',
        element: <Callback />,
      },
      {
        path: '/terms',
        isPrivate: true,
        element: <TermsOfServicePage />,
      },
    ],
  },
]
